<template>
  <div>
    <el-dialog
      :title="titleWord"
      :visible.sync="dialogVisible"
      width="550px"
    >
      <span>{{ innerInfo }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="isWarning" type="danger" @click="comFirmBtn">确 定</el-button>
        <el-button v-if="!isWarning" type="primary" @click="comFirmBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WarningDialog',
  props: {
    isWarning: {
      type: Boolean,
      default: true,
    },
    titleWord: {
      type: String,
      default: '提示',
    },
    innerInfo: String,
    comFirmBtn: Function,
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
}
</script>

<style scoped>

</style>
